// extracted by mini-css-extract-plugin
export default {"wrapper":"SB-z","viewport":"TB-z","container":"UB-z","slide":"VB-z"};